module.exports = __webpack_public_path__ + "img/bid_agent-3.d74ecc17.png";